export const getClientOS = (): string => {
  if (typeof navigator === 'undefined') return 'unknown';

  const ua = navigator.userAgent;

  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
  if (/Android/.test(ua)) return 'Android';
  if (/Mac OS X|Macintosh/.test(ua)) return 'macOS';
  if (/Windows/.test(ua)) return 'Windows';
  if (/CrOS/.test(ua)) return 'ChromeOS';
  if (/Linux/.test(ua)) return 'Linux';

  return 'unknown';
};

export const getDeviceType = (): string => {
  if (typeof navigator === 'undefined') return 'unknown';
  return /Mobi|Android/i.test(navigator.userAgent) ? 'mobile_web' : 'desktop';
};
